export enum EnvName {
    LOCAL = 'LOCAL',
    DEV = 'DEV',
    INT = 'INT',
    PROD = 'PROD',
}
export interface Environment {
    NAME: EnvName;
    SERVICES_BASE_URL: string;
    ROLE_PREFIX: string;
    UMAS_LINK: string;
    DEPLOY_ENV: EnvName;
    SEARCH_DEBOUNCE_MS?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface EnvSettings {}

export interface EndpointConfig {
    name: string;
    env: Environment;
    settings: EnvSettings;
}

export type WindowConfig = Window & typeof globalThis & { endpointConfig: EndpointConfig };

//TODO: always build with prod env, only use dev env when starting with npm run start. Base url is set to localhost for run start.
const endpointConfigs: { [key: string]: Environment } = {
    DEV: {
        NAME: EnvName.DEV,
        SERVICES_BASE_URL: process.env.SERVICE_BASE_URL ?? '',
        ROLE_PREFIX: 'BEAM2',
        UMAS_LINK: process.env.UMAS_LINK ?? '',
        DEPLOY_ENV: EnvName.DEV,
        SEARCH_DEBOUNCE_MS: process.env.SEARCH_DEBOUNCE_MS,
    },
    PROD: {
        NAME: EnvName.PROD,
        // Since we have a INTERNAL and a PUBLIC URL, we use the origin of the current page to determine which one to use
        // This is only relevant for the PROD environment, as the other environments have unique URLs
        //TODO: why setting it then for the other env? we could easyly use reltive pathes there as well.
        //anyway, when this is needed to be variable, you can go this approach
        SERVICES_BASE_URL: 'https://beam.i.mercedes-benz.com',
        ROLE_PREFIX: 'BEAM2',
        UMAS_LINK: 'https://aftersales.mercedes-benz.com/spa/registration?app=BEAM',
        DEPLOY_ENV: 'PROD' as EnvName,
        SEARCH_DEBOUNCE_MS: '1500',
    },
};

const beamEnv = process.env.BEAM_ENV;

if (!beamEnv || !Object.keys(endpointConfigs).includes(beamEnv)) {
    const errorMsg = `Invalid or missing BEAM_ENV environment variable: "${beamEnv}".`;

    // At this point the app is not rendered yet, so we need to create a div to show the error manually

    if (typeof window !== 'undefined' && document.body) {
        const errorDiv = document.createElement('div');
        errorDiv.style.background = '#ffdddd';
        errorDiv.style.color = '#a00';
        errorDiv.style.padding = '16px';
        errorDiv.style.fontSize = '24px';
        errorDiv.style.fontWeight = 'bold';
        errorDiv.innerText = errorMsg;
        document.body.prepend(errorDiv);
    }
    throw new Error(errorMsg);
}

export const endpointConfig = {
    name: 'default',
    env: endpointConfigs[beamEnv],
    settings: {},
};
